/* eslint-disable max-len */
import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import MultiDropdown from './MultiDropdown';

export const PLACEHOLDER = 'Show placeholder';
export const FIRSTOPTION = 'Show first dropdown option';
export const CURRENTOPTION = 'Show current selected option';

const {
    schema: generatedSchema,
    uiSchema: generatedUiSchema,
    group: generatedGroup,
    dependencies: generatedDependencies,
} = customSchemas.GenerateAnalyticsSchema(['Selected Dropdown']);

const schema: JSONSchema7 = {
    title: 'Multi Dropdown',
    type: 'object',
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        ...generatedSchema,
        dropdowns: {
            type: 'array',
            title: 'Add dropdowns',
            items: {
                type: 'object',
                properties: {
                    isDependent: {
                        type: 'boolean',
                        title: 'Is dropdown dependent on other dropdown',
                        default: false,
                    },
                    id: {
                        type: 'string',
                        title: 'Enter dropdown id',
                    },
                    label: {
                        type: 'string',
                        title: 'Enter dropdown label',
                    },
                    ariaLabel: {
                        type: 'string',
                        title: 'Enter dropdown aria label',
                    },
                    dataKey: {
                        type: 'string',
                        title: 'Enter data key for dropdown list',
                        description: 'Enter JSON path',
                    },
                    itemDataKey: {
                        type: 'string',
                        title: 'Enter data key for dropdown item',
                        description: 'The data key for the dropdown item within the dropdown list.',
                    },
                    currenItemDatakey: {
                        type: 'string',
                        title: 'Enter data key for current value',
                        description: 'The data key for the current value within the dropdown list.',
                    },
                    linkDataKey: {
                        type: 'string',
                        title: 'Enter link data key',
                        description:
                            'The data key for the dropdown item to navigate to within the dropdown list.',
                    },
                    defaultValueOption: {
                        type: 'string',
                        title: 'Select default value type',
                        enum: [PLACEHOLDER, FIRSTOPTION, CURRENTOPTION],
                        default: CURRENTOPTION,
                    },
                    targetTop: {
                        type: 'boolean',
                        title: 'Allow navigate top window',
                        description: 'If within iframe navigate parent window or not',
                        default: false,
                    },
                    showSearch: {
                        type: 'boolean',
                        title: 'Show search input',
                        default: false,
                    },
                    iconPosition: {
                        type: 'string',
                        title: 'Choose dropdown icon position',
                        enum: ['Right', 'Left'],
                        default: 'Right',
                    },
                    iconType: {
                        type: 'string',
                        title: 'Choose dropdown icon type',
                        enum: ['FontAwesome Icon', 'Image'],
                        default: 'FontAwesome Icon',
                    },
                    useCustomUrl: {
                        type: 'boolean',
                        title: 'Use Custom Url',
                        default: false,
                    },
                },
                required: ['id'],
                dependencies: {
                    isDependent: {
                        oneOf: [
                            {
                                properties: {
                                    isDependent: { enum: [true] },
                                    parentDropdownId: {
                                        type: 'string',
                                        title: 'Select id of dropdown which this dropdown dependent on',
                                    },
                                },
                            },
                            {
                                properties: {
                                    isDependent: { enum: [false] },
                                },
                            },
                        ],
                    },
                    targetTop: {
                        oneOf: [
                            {
                                properties: {
                                    targetTop: { enum: [true] },
                                    topURLDataKey: {
                                        type: 'string',
                                        title: 'Enter top window URL Data key',
                                    },
                                },
                            },
                            {
                                properties: {
                                    targetTop: { enum: [false] },
                                },
                            },
                        ],
                    },
                    defaultValueOption: {
                        oneOf: [
                            {
                                properties: {
                                    defaultValueOption: { enum: [PLACEHOLDER] },
                                    placeholder: {
                                        type: 'string',
                                        description: 'Enter placeholder',
                                    },
                                },
                            },
                            {
                                properties: {
                                    defaultValueOption: { enum: [FIRSTOPTION] },
                                },
                            },
                            {
                                properties: {
                                    defaultValueOption: { enum: [CURRENTOPTION] },
                                    currentItemDatakey: {
                                        type: 'string',
                                        title: 'Enter key for current item',
                                    },
                                },
                            },
                        ],
                    },
                    showSearch: {
                        oneOf: [
                            {
                                properties: {
                                    showSearch: { enum: [true] },
                                    searchPlaceholder: {
                                        type: 'string',
                                        title: 'Search placeholder text',
                                    },
                                    noOptionFoundText: {
                                        type: 'string',
                                        title: 'Enter no option found text',
                                    },
                                    showSearchIcon: {
                                        type: 'boolean',
                                        title: 'Show dropdown search icon',
                                        enum: [true, false],
                                        default: false,
                                    },
                                },
                                dependencies: {
                                    showSearchIcon: {
                                        oneOf: [
                                            {
                                                properties: {
                                                    showSearchIcon: {
                                                        enum: [true],
                                                    },
                                                    searchIconPosition: {
                                                        type: 'string',
                                                        title: 'Choose dropdown search icon position',
                                                        enum: ['Right', 'Left'],
                                                        default: 'Right',
                                                    },
                                                    searchIconType: {
                                                        type: 'string',
                                                        title: 'Choose dropdown serach icon type',
                                                        enum: ['FontAwesome Icon', 'Image'],
                                                        default: 'FontAwesome Icon',
                                                    },
                                                },
                                                dependencies: {
                                                    searchIconType: {
                                                        oneOf: [
                                                            {
                                                                properties: {
                                                                    searchIconType: {
                                                                        enum: ['FontAwesome Icon'],
                                                                    },
                                                                    searchIcon: {
                                                                        type: 'string',
                                                                        title: 'Enter dropdown search icon name',
                                                                        default: 'fa-search',
                                                                    },
                                                                    searchCancelIcon: {
                                                                        type: 'string',
                                                                        title: 'Enter dropdown search cancel icon name',
                                                                        default: 'fa-search',
                                                                    },
                                                                },
                                                            },
                                                            {
                                                                properties: {
                                                                    searchIconType: {
                                                                        enum: ['Image'],
                                                                    },
                                                                    searchImageUrl: {
                                                                        type: 'string',
                                                                        title: 'Enter dropdown search image url',
                                                                    },
                                                                    searchCancelImageUrl: {
                                                                        type: 'string',
                                                                        title: 'Enter dropdown search cancel image url',
                                                                        default: 'fa-search',
                                                                    },
                                                                },
                                                            },
                                                        ],
                                                    },
                                                },
                                            },
                                            {
                                                properties: {
                                                    showSearchIcon: {
                                                        enum: [false],
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                            {
                                properties: {
                                    showSearch: { enum: [false] },
                                },
                            },
                        ],
                    },
                    iconType: {
                        oneOf: [
                            {
                                properties: {
                                    iconType: {
                                        enum: ['FontAwesome Icon'],
                                    },
                                    dropdownOpenIcon: {
                                        type: 'string',
                                        title: 'Enter dropdown open icon name',
                                        default: 'fa-chevron-down',
                                    },
                                    dropdownCloseIcon: {
                                        type: 'string',
                                        title: 'Enter dropdown close icon name',
                                        default: 'fa-chevron-up',
                                    },
                                },
                            },
                            {
                                properties: {
                                    iconType: {
                                        enum: ['Image'],
                                    },
                                    dropdownOpenImage: {
                                        type: 'string',
                                        title: 'Enter dropdown open image url',
                                    },
                                    dropdownCloseImage: {
                                        type: 'string',
                                        title: 'Enter dropdown close image url',
                                    },
                                },
                            },
                        ],
                    },
                    useCustomUrl: {
                        oneOf: [
                            {
                                properties: {
                                    useCustomUrl: { enum: [true] },
                                    customUrl: {
                                        type: 'string',
                                        description: 'Custom url data key',
                                        default: '',
                                    },
                                },
                            },
                            {
                                properties: {
                                    useCustomUrl: { enum: [false] },
                                },
                            },
                        ],
                    },
                },
            },
        },
        transformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
    },
    dependencies: {
        transformData: {
            oneOf: [
                {
                    properties: {
                        transformData: { enum: [true] },
                        functionToTransformData: {
                            type: 'string',
                            description: 'Function to transform Data',
                            default: 'return (data) => { return data}',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
        ...generatedDependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        'Dropdown Options': ['dropdowns'],
        ...generatedGroup,
        'Transform Data': ['transformData', 'functionToTransformData'],
    },
];

const MultiDropdownSchema: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        ...generatedUiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        dropdowns: {
            items: {
                'ui:field': 'CollapsibleFieldTemplate',
                'ui:order': [
                    'isDependent',
                    'parentDropdownId',
                    'openAfterParent',
                    'id',
                    'label',
                    'ariaLabel',
                    'dataKey',
                    'itemDataKey',
                    'currenItemDatakey',
                    'linkDataKey',
                    'defaultValueOption',
                    'placeholder',
                    'currentItemDatakey',
                    'iconPosition',
                    'iconType',
                    'dropdownOpenIcon',
                    'dropdownCloseIcon',
                    'dropdownOpenImage',
                    'dropdownCloseImage',
                    'targetTop',
                    'topURLDataKey',
                    'showSearch',
                    'searchPlaceholder',
                    'noOptionFoundText',
                    'showSearchIcon',
                    'searchIconPosition',
                    'searchIconType',
                    'searchIcon',
                    'searchImageUrl',
                    'useCustomUrl',
                    'customUrl',
                    '*',
                ],
                id: { 'ui:widget': 'CustomTextInput' },
                label: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                ariaLabel: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                dataKey: { 'ui:widget': 'ResourcePicker' },
                itemDataKey: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                currenItemDatakey: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                linkDataKey: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                defaultValueOption: { 'ui:widget': 'CustomSelect' },
                placeholder: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                currentItemDatakey: { 'ui:widget': 'ResourcePicker' },
                targetTop: { 'ui:widget': 'CustomCheckbox' },
                topURLDataKey: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                showSearch: { 'ui:widget': 'CustomCheckbox' },
                searchPlaceholder: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                noOptionFoundText: { 'ui:widget': 'ResourcePicker', 'ui:placeholder': '{{ }}' },
                showSearchIcon: { 'ui:widget': 'CustomCheckbox' },
                searchIconPosition: { 'ui:widget': 'CustomSelect' },
                searchIconType: { 'ui:widget': 'CustomSelect' },
                searchIcon: { 'ui:widget': 'CustomTextInput' },
                searchCancelIcon: { 'ui:widget': 'CustomTextInput' },
                searchImageUrl: {
                    'ui:placeholder': 'https://',
                    'ui:widget': 'MediaPicker',
                    'ui:options': {
                        isImagePicker: true,
                    },
                },
                searchCancelImageUrl: {
                    'ui:placeholder': 'https://',
                    'ui:widget': 'MediaPicker',
                    'ui:options': {
                        isImagePicker: true,
                    },
                },
                isDependent: { 'ui:widget': 'CustomCheckbox' },
                parentDropdownId: {
                    'ui:widget': 'FormDataMultiSelect',
                    customProps: { dataKey: 'dropdowns.id' },
                },
                openAfterParent: { 'ui:widget': 'CustomCheckbox' },
                dependentDataKey: { 'ui:widget': 'ResourcePicker' },
                iconPosition: { 'ui:widget': 'CustomSelect' },
                iconType: { 'ui:widget': 'CustomSelect' },
                dropdownOpenIcon: { 'ui:widget': 'CustomTextInput' },
                dropdownCloseIcon: { 'ui:widget': 'CustomTextInput' },
                dropdownOpenImage: {
                    'ui:placeholder': 'https://',
                    'ui:widget': 'MediaPicker',
                    'ui:options': {
                        isImagePicker: true,
                    },
                },
                dropdownCloseImage: {
                    'ui:placeholder': 'https://',
                    'ui:widget': 'MediaPicker',
                    'ui:options': {
                        isImagePicker: true,
                    },
                },
                useCustomUrl: { 'ui:widget': 'CustomCheckbox' },
                customUrl: {
                    'ui:widget': 'CustomTextInput',
                },
            },
        },
        functionToTransformData: { 'ui:widget': 'JSEditor' },
    },
    group: 'component',
    templateView: MultiDropdown,
    id: 'MultiDropdown',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default MultiDropdownSchema;
